// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-account-settings-branding-trip-alert-branding-module__root--Dybxt {
  background-color: #7a8794;
  padding: 10px 10px 20px 10px;
}

h3 {
  margin: 10px 0;
}

h5,
.src-js-account-settings-branding-trip-alert-branding-module__save--d_G4W {
  margin-top: 30px;
}

.src-js-account-settings-branding-trip-alert-branding-module__loadingSpinner--qSDvG {
  padding: 10px;
}

.src-js-account-settings-branding-trip-alert-branding-module__message--KA7QN {
  padding: 5px 10px;
  border-radius: 4px;
}

.src-js-account-settings-branding-trip-alert-branding-module__failedSaveError--P_gSg {
  margin-top: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/js/account/settings/branding/trip-alert-branding.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".root {\n  background-color: #7a8794;\n  padding: 10px 10px 20px 10px;\n}\n\nh3 {\n  margin: 10px 0;\n}\n\nh5,\n.save {\n  margin-top: 30px;\n}\n\n.loadingSpinner {\n  padding: 10px;\n}\n\n.message {\n  padding: 5px 10px;\n  border-radius: 4px;\n}\n\n.failedSaveError {\n  margin-top: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-js-account-settings-branding-trip-alert-branding-module__root--Dybxt`,
	"save": `src-js-account-settings-branding-trip-alert-branding-module__save--d_G4W`,
	"loadingSpinner": `src-js-account-settings-branding-trip-alert-branding-module__loadingSpinner--qSDvG`,
	"message": `src-js-account-settings-branding-trip-alert-branding-module__message--KA7QN`,
	"failedSaveError": `src-js-account-settings-branding-trip-alert-branding-module__failedSaveError--P_gSg`
};
export default ___CSS_LOADER_EXPORT___;
